import type { WebLocale } from '@/enums/web-locale';

import { CCPA_SUBDIVISION, GDPR_WEB_LOCALES } from '@/constants/web-locales.constant';

import { getUserLocationSubdivision } from '@/helpers/geo-location-helper';

export function hasUCConsentBanner(webLocale: WebLocale, includeCCPA = true): boolean {
	if (import.meta.server) return false;

	return GDPR_WEB_LOCALES.includes(webLocale) || (includeCCPA && hasCCPABanner());
}

export function hasCCPABanner(): boolean {
	if (import.meta.server) return false;

	const subdivision = getUserLocationSubdivision() || '';
	return CCPA_SUBDIVISION.includes(subdivision);
}
